<template>
  <div>
    <div class="ou-donation-form" :class="{ 'fullwidth': inHonorOf }">
      <div class="holder">
        <h2 class="h2__mixed">
            <span>Support</span> {{ form.applications && form.applications[0] && form.applications[0].department === 'NCSY_Tristate' ? '4G' : 'the NCSY' }}
            
        </h2>
        <PaymentForm class="form-horizontal">
          <div class="steps-bar">
            <div
              v-for="(step, index) in steps"
              :key="index"
              :class="{
                'steps-bar__item--last': index >= steps.length - 1,
                'steps-bar__item--active': currentStep >= index + 1,
                'steps-bar__item--current-active': currentStep === index + 1,
              }"
              class="steps-bar__item"
            >
                <div class="steps-bar__item__text">{{ step }}

                  <svg  class="steps-bar__svg" v-if="(currentStep >= index + 1) && ( currentStep !== index + 1)" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33301 10.2612L8.04705 14.9753L17.4751 5.54719" stroke="#9ABBFF" stroke-width="1.3" stroke-linecap="round"/></svg>
                </div>
              <div class="steps-bar__item-dot"><span></span></div>
              <!--  -->
              <div class="steps-bar__item-line"></div>

            </div>
          </div>

          <div v-if="currentStep === 1" class="step">
            <section>
              <h2>I would like to give:</h2>
              <div class="donatem__section">
              <div class="donatem__right">
              <div class="donateion__list">
                <NcsyModalAmounts />
                <ErrorLabel field="amount" />
              </div>
                <div class="multiple__payoptions">
                <NcsyModalPaymentsOptions addMonthly  monthesSelector/>
              </div>

              <div class="dedicate__mobile__info">
              <div class="dedicate__modals">
                	<FormRow>
                    <input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/> 
                    <FormLabel for="inHonorOf">Dedicate your donation</FormLabel>
                </FormRow>
              </div>
            <div class="transfee" v-if="form.amount">
              <div v-if="form.amount && form.gateway !== 'check' && form.gateway !== 'wire'">
                <div class="fee-info-container">      
                  By covering the transaction fees, you are completely eliminating {{ displayDept }} payment processing overhead and enabling them to receive 100% of your intended donation.
                  <br/>
                  <div class="flex">
                    <input type="checkbox" id="cover" :checked="form.handleProcessing" @change="setValue('handleProcessing', $event.target.checked)"/>
                    <FormLabel for="cover">
                      Yes, include a transaction fee of 
                      <MoneyFormat class="amount" :value="parseInt(form.amount) * feePercent / 100" :currencyCode="form.currency" />
                      so that 100% of your donation goes to {{ displayDept }}
                    </FormLabel>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>

            <div class="donatem__left" v-if="inHonorOf">
              <div  class="honor-container">
                <FormRow class="honor__row" inline>
                  <FormSelect class="honor__field" field="dedication" :showLabel="false">
                    <option value="">Dedication</option>                    
                    <option value="In honor of">In honor of</option>
                    <option value="In memory of">In memory of</option>
                    <option value="For the recovery of">For the recovery of</option>
                  </FormSelect>
                    <FormInput type="text" placeholder="Honoree Name" field="honoreeName" :showLabel="false"/>
                </FormRow>
                <FormRow inline>
                  <FormInput type="text" placeholder="Dedication Message" field="dedicationMessage" :showLabel="false"/>
                </FormRow>
                <FormRow class="honor__row" inline v-if="recipientFlag">
                    <FormInput type="text" placeholder="Recipient Name" field="recipientName" :showLabel="false"/>
                    <FormInput type="text" placeholder="Recipient Email" field="recipientEmail" :showLabel="false"/>
                </FormRow>
                <FormRow inline>
                  <span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}" v-if="recipientFlag">				
                    <!-- <span v-if="!recipientFlag">+ Add </span> -->
                    Remove recipient <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5 5L14.9998 14.9998" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/> <path d="M5 15L14.9998 5.00017" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                  </span>                  
                  <span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}" v-if="!recipientFlag">				
                    Add recipient +
                  </span> 
                </FormRow>
              </div>
            </div>
            </div>
          </section>
          <!-- <PaymentButton showAmount btnText="Donate" /> -->
            <div
              class="step__btn-wrapper"
              v-if="form.amount && Number(form.amount) > 0"
            >
              <div class="btn__blue" @click="currentStep = 2">Next Step</div>
            </div>
          </div>

          <div v-if="currentStep === 2" class="step step--lg">
            <h2>Personal Information</h2>
            
              <div class="personal__info" id="personalInfo">
                <FormRow  class="personal__firstrow" inline>
                  <div class="dform__col">
                  <FormSelect field="title" class="personal__title">      
                        <option value="">Title</option>
                        <option value="Mr">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Rabbi">Rabbi</option>
                        <option value="Rebbetzin">Rebbetzin</option>
                        <option value="Rabbanit">Rabbanit</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Dr. Rabbi">Dr. Rabbi</option>
                        <option value="Rabbi Dr." v-if="!simple">Rabbi Dr.</option>
                        <option value="Sir">Sir</option>
                        <option value="The honorable">The Honorable</option>
                        <option value="Chaplain">Chaplain</option>
                    </FormSelect>    
                  </div>
                  <div class="dform__col">
                  <FormInput type="text" placeholder="First Name" field="firstName" :showLabel="false" :flex="1"/>
                  <ErrorLabel field="firstName" />
                  </div>                  
                  <div class="dform__col">
                  <FormInput type="text" placeholder="Last Name" field="lastName" :showLabel="false" :flex="1"/>
                  <ErrorLabel field="lastName" />
                  </div>
                </FormRow>
                
                  <FormRow class="dform__rowdouble" inline>
                    <div class="dform__col">
                      <FormInput type="email" placeholder="Email" field="email" :showLabel="false"/>
                         <ErrorLabel field="email" />
                    </div>
                    <div class="dform__col">    
                      <FormCol field="phone" :flex="1" :showLabel="false" class="personal__phone">
                      <PhoneField placeholder="Phone" />
                    </FormCol>                                     
                      </div>
                  </FormRow>
                  <FormRow class="personal__firstrow" inline>
                    <div class="dform__col"> 
                      <FormInput type="text" placeholder="Street" field="street" :showLabel="false" :flex="1"/>
                       <ErrorLabel field="street" />
                    </div>
                    <div class="dform__col"> 
                      <FormInput type="text" placeholder="Street 2" field="street2" :showLabel="false" :flex="1"/>
                       <ErrorLabel field="street2" />
                    </div>  
                    <div class="dform__col">        
                      <FormInput type="text" placeholder="City" field="city" :showLabel="false" :flex="1"/>
                       <ErrorLabel field="city" />
                    </div>                    
                  </FormRow>
                  <FormRow  class="personal__firstrow" inline>
                    <div class="dform__col">
                      <FormSelect field="state" :disabled="form.country !== 'US' && form.country !== 'CA'" :class="{ 'personal__statehide': form.country !== 'US' && form.country !== 'CA' }">
                        <option value="" disabled selected hidden>State</option>
                        <option v-for="state of stateOptions" :key="state[1]" :value="state[1]">{{state[0]}}</option>
                      </FormSelect>    
                      <ErrorLabel field="state" />     
                    </div>        
                      <div class="dform__col">
                        <FormInput type="text" placeholder="Zip" field="zip" :showLabel="false" :flex="1"/>
                        <ErrorLabel field="zip" /> 
                      </div>                      
                      <div class="dform__col">
                      <FormCol
                      class="personal__country"
                        field="country"
                        :showLabel="false"
                        :placeholder="true"
                        placeholderText="Country"
                      >
                        <CountrySelector />
                      </FormCol>
                        <ErrorLabel field="country" />     
                      </div>

                  </FormRow>

                  <div class="phonec__consent">
                        <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </div>
                
              </div>

              <div class="step__btn-wrapper">
              <div class="btn__white" @click="currentStep = 1">Back</div>
              <div class="btn__blue" @click="validateAndNext">Next Step</div>
            </div>

            <!-- <div class="step__btn-wrapper">
              <div class="btn btn--prev" @click="currentStep = 1">Previous</div>
              <div class="btn btn--negative" @click="currentStep = 3">Next</div>
            </div> -->
          </div>

          <div v-if="currentStep === 3" class="step">
            <div class="gift__setup">

              <h2>Please allocate my gift to:</h2>

              <div class="personal__info" id="designation">
                  <FormRow class="dform__rowdouble" inline v-if="form.applications[0].department == 'NCSY_AtlanticSeaboard'">
                    <div class="dform__col dform__col--designation">
                        <FormSelect field="applications.0.campaign">
                          <option selected="selected" value="General Donation">General Donation</option>
                          <option value="JSU Donation">JSU Donation</option>
                          <option value="Summer Scholarship">Gap Year Scholarship</option>
                          <option value="Latte & Learning">Latte & Learning</option>
                          <option value="Concert">Concert</option>
                          <option value="Pledge Payment">Pledge Payment</option>
                          <option value="JSU Expansion">JSU Expansion</option>
                        </FormSelect>
                    </div>
                    <div class="dform__col dform__col--designation">    
              <FormSelect field="applications.0.subCampaign">
                <option value="" disabled selected hidden>Select Chapter</option>
                <option value="Baltimore">Baltimore</option>
                <option value="Cherry Hill">Cherry Hill</option>
                <option value="Greater Washington">Greater Washington</option>
                <option value="Philadelphia">Philadelphia</option>
                <option value="Richmond">Richmond</option>
              </FormSelect>                             
                      </div>
                  </FormRow>

                  <FormRow class="dform__rowdouble" inline v-if="form.applications[0].department == 'NCSY_Tristate'">
                    <div class="dform__col dform__col--designation">
                      <FormSelect field="applications.0.subCampaign">
                <option value="" disabled selected hidden>Select Chapter</option>
                <option value="General 4G">General 4G</option>
                <option value="4G Teaneck">4G Teaneck</option>
                <option value="4G Five Towns">4G Five Towns</option>
                <option value="4G Brooklyn">4G Brooklyn</option>
                <option value="4G Queens">4G Queens</option>
                <option value="4G Passaic">4G Passaic</option>
                <option value="4G Monsey">4G Monsey</option>
              </FormSelect>          
                    </div>
                  </FormRow>

                  </div>

                <div class="personal__info" id="notes" style=" padding-top: 0px;">
                                <h2>Notes</h2>
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
            </div>            
            </div>            
            <div class="step__btn-wrapper">
              <!-- <div class="btn btn--prev" @click="currentStep = 2">Previous</div> -->
              <div class="btn__white" @click="currentStep = 2">Back</div>
              <div class="btn__blue" @click="currentStep = 4">Next</div>
            </div>
          </div>
          <div v-if="currentStep === 4" class="step">
            <div class="payment__info" title="Payment Information" last>
              <h2>Payment Information</h2>
              
              <div class="payment__cc">
       <FormRow>
                <PaymentType cc_text="Credit Card" check_text="Check/DAF" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center;flex-flow: column;gap: 20px;align-items: center;text-align: center;"
                class="checktext"
              >
                <div>
                  <strong>Please mail your check to the following address:</strong>
                  <p style="text-align: center">
                   Atlantic Seaboard NCSY<br />
                     307 Reisterstown Road<br />
                     Baltimore, MD 21208
                  </p>
                </div>
              <div>
                  <strong>For Donor-Advised Funds (DAF):</strong>
                  <p style="text-align: center">
                    Our legal name is Union of Orthodox Jewish Congregations of America, and our EIN is 13-5623717.<br />
                    Please direct DAF contributions to:<br />
                   40 Rector Street<br />New York, NY 10004
                  </p>
                </div>                
              </FormRow>
              </div>
            </div>
            
            <div class="step__btn-wrapper">
               <div class="btn__white" @click="currentStep = 3">Back</div>
                <button
                  type="submit"
                  name="submit"
                  id="donate-widget-form-submit"
                  class="ougiving__btn"
                  formnovalidate="formnovalidate"
                >
                    <span v-if="processing">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </span>
                    <span v-else class="btnpayment__text">
                    
                      Donate
                      <MoneyFormat
                        v-if="form.amount"
                        class="amount"
                        :value="amount"
                        :currencyCode="form.currency"
                      />
                    </span>
                  </button>
                </div>

          </div>
        </PaymentForm>
      </div>

      <div class="donation__vector">
        <img src="./ncsy-modal-logo.svg" alt="NCSY Logo" class="donation__vector-image" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch, computed, inject, nextTick } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'
import { string } from 'zod'

import FormSelect from '~/components/form-select.vue'
import MoneyFormat from '~/components/MoneyFormat.vue'

const states = [
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Lousiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
]

const provinces = [
  ['Alberta', 'AB'],
  ['British Columbia', 'BC'],
  ['Manitoba', 'MB'],
  ['New Brunswick', 'NB'],
  ['Newfoundland', 'NL'],
  ['Northwest Territories', 'NT'],
  ['Nova Scotia', 'NS'],
  ['Nunavut', 'NU'],
  ['Ontario', 'ON'],
  ['Prince Edward Island', 'PE'],
  ['Quebec', 'QC'],
  ['Saskatchewan', 'SK'],
  ['Yukon', 'YT'],
]

export default defineComponent({
  components: {
    MoneyFormat
  },
  setup(_props: {}) {
    const { form, setValue, getValue, setTouched, errors, submit, submitting } = usePaymentForm()
      const params = queryParams()
    const feePercent = 2.5
    const inHonorOf = ref(false)
	  const recipientFlag = true
    const state = ref(false)
    const selected = ref(false)
    const customSelected = ref(false);
    const currentStep = ref(1)

    if (params.amount) {
      nextTick(() => setValue('amount', params.amount))
      // If amount provided via URL params, skip to step 2 (Personal Info)
      currentStep.value = 2
    }

    if (params.inHonorOf === 'true') {
      inHonorOf.value = true
    }

    if (params.dayOfMonth) {
      nextTick(() => setValue('dayOfMonth', params.dayOfMonth))
    }

    if (params.periodMonths) {
      nextTick(() => setValue('periodMonths', params.periodMonths))
      // periodMonths only applies to monthly giving, so default dayOfMonth
      // to today if it wasn't explicitly provided in the URL
      if (!params.dayOfMonth) {
        nextTick(() => setValue('dayOfMonth', '' + new Date().getDate()))
      }
    }

    if (params.handleProcessing === 'true') {
      nextTick(() => setValue('handleProcessing', true))
    }
    const steps = [
      'Donation Amount',
      'Personal Info',
      'Gift Allocation',
      'Payment',
    ]

    const validateAndNext = () => {
      // Touch all fields to trigger error display
      const fieldsToValidate = ['firstName', 'lastName', 'email', 'country', 'city', 'street', 'state', 'zip', 'phone'] as const
      
      fieldsToValidate.forEach(field => {
        setTouched(field as any)
      })

      // Check if there are any errors before proceeding
      if (Object.keys(errors.value).length === 0) {
        currentStep.value = 3
      }
    }

    // State selector logic
    watch(
      () => form.value.country,
      () => setValue('state', null)
    );

    watch(
      () => form.value.applications[0].department,
      (val) => {
        if (val == "ImpactAccelerator" || !val) {
          setValue("applications.0.campaign", "Communal Entrepreneurship");
        } else {
          setValue("applications.0.campaign", "General Donation");
        }
      }
    );

    const amount = computed(() => {
      const baseAmount = Number(form.value.amount) || 0
      const isHandlingProcessing = Boolean(form.value.handleProcessing)
      const gateway = form.value.gateway
      const transactionFee = Number(form.value.transactionFee) || 2.5
      
      let calculatedAmount = ['wire', 'check'].includes(String(gateway || ''))
      ? baseAmount
      : isHandlingProcessing
        ? Math.round((baseAmount + baseAmount * transactionFee / 100) * 100) / 100
        : baseAmount;
      
      if (form.value.periodMonths && form.value.dayOfMonth) {
        calculatedAmount *= Number(form.value.periodMonths);
      }

      return calculatedAmount;
    });

    const stateOptions = computed(() => {
      if (form.value.country == 'US') return states
      if (form.value.country == 'CA') return provinces
      return []
    })

    const displayDept = computed(() => {
      let raw = (form.value.applications?.[0]?.department || '').replace(/_/g, ' ')
      if (!raw) return ''
      // Expand 'AtlanticSeaboard' wherever it appears (standalone or within a longer string)
      raw = raw.replace(/AtlanticSeaboard/g, 'Atlantic Seaboard')
      return raw
    })

    const goBack = () => {
      if (currentStep.value > 1) {
        currentStep.value -= 1
      }
    }

    return {
      processing: submitting,
      form,
      getValue,
      amount,
      steps,
      feePercent,
      finished: false,
      setValue,
      submit,
      currentStep,
      customSelected,
      selected,
      state,
      stateOptions,
      inHonorOf,
      validateAndNext,
      recipientFlag,
      goBack,
      displayDept
    }
  },
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

:deep(.ou-donation-form) {
  max-width: 980px;
  background: #183346;
  width: 100%;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  color: #ffffff;
  padding-top: 40px;
  padding-bottom: 60px;
  transition: all 0.1s ease-in-out;
      @media only screen and (max-width: 720px) {
      padding: 28px 20px 60px;    
    }
&.fullwidth{
    max-width: 1248px;
}
}
:deep(.ou-donation-form) {
  line-height: 1.4;
  h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #ffffff;
    margin-top: 0px;
    margin-bottom: 12px;
      @media only screen and (max-width: 720px) {
      font-size: 18px;
    line-height: 26px;
    }
  }

  input[type='email'],
  input[type='number'],
  input[type='password'],
  input[type='tel'],
  input[type='text'],
  textarea,
  select {
    font-size: 14px;
  }
  input[type='tel'] {
    height: 42px;
  }
}
:deep(.frequency) {
  display: flex;
  justify-content: space-between;

 
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
input[type='checkbox'] {
  margin-right: 5px;
}

// ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:not(:checked) + label[data-amount="100"] {
//   background: #eee7fd;
// }

:deep(.ou-donation-form .ou-donation-btn) {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}
:deep(.thank-you-container .ou-donation-btn) {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}

.steps-bar {
  max-width: 567px;
  display: flex;
  padding-top: 20px;
  margin: 0px auto 40px;
  justify-content: space-between;
          @media only screen and (max-width: 720px) {
            margin: 0px auto 28px;
              padding-top: 0px;
          }

}
.steps-bar__item {
    display: flex;
    position: relative;
    flex: 25%;
    flex-flow: column;
    align-items: center;
    justify-content: center;

  &.steps-bar__item--last {
    flex-grow: 0;
    .steps-bar__item-dot::after{
      background: #183346;
    }
  }
  &.steps-bar__item--active {
    .steps-bar__item-dot {
      span{
        background: #F87507;
        border: 1px solid #F87507;
      }
      &::after{
            background: #F87507;
      }
    }
    
    &:last-child {

    }
  }  
  &.steps-bar__item--current-active {
    .steps-bar__item__text{
          color: #FFFFFF;

    }
    .steps-bar__item-dot {
        &::after{
          background: #9ABBFF;
        }
      }
  }
  &.steps-bar__item--last{
    .steps-bar__item-dot{
           &::after{
          display: none !important;
          }
    } 
  }
}

.steps-bar__item__text {
    gap: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #9ABBFF;
    mix-blend-mode: normal;
    text-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    padding-bottom: 8px;
        @media only screen and (max-width: 720px) {
        max-width: 55px;
        height: 32px;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #9ABBFF;
        mix-blend-mode: normal;
        text-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
        }
}
.steps-bar__item-dot {
  width: 14px;
  border-radius: 50%;
  height: 14px;
  z-index: 1;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: center;
  mix-blend-mode: normal;
  &::after{
    content: "";
    width: 100%;
    z-index: 0;
    position: absolute;
    height: 1px;
    background: #9ABBFF;
  }
  span{
     width: 14px;
  border-radius: 50%;
  height: 14px;
  z-index: 1;
  position: relative;
  display: flex;
  background: #183346;
  border: 1px solid #9ABBFF;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: center;
  mix-blend-mode: normal; 
  }
}
.steps-bar__item-line {
height: 1px;
    background: #9ABBFF;
  flex-grow: 1;
  top: 8px;
  position: relative;
}

.step__btn-wrapper {
  display: flex;
  // max-width: 330px;
  gap: 12px;
  padding-top: 40px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
        @media only screen and (max-width: 720px) {
          padding-top: 28px;
            gap: 16px;
            flex-flow: row;
        }
}

.step {
  margin: 0 auto;

  // &.step--lg {
  //   max-width: 100%;
  // }
}
.btn {
  padding: 13px 35px 11px 35px;
  border: 1px solid #15329d;
  color: #15329d;
  font-size: 16px;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  margin-bottom: 15px;
  padding-right: 25px;
  padding-left: 25px;
  margin-left: auto;

  &.btn--negative {
    background: #15329d;
    color: white;
  }
  &.btn.btn--disabled {
    opacity: 1;
    filter: grayscale(100%);
    background: #fafafa;
    color: #b9b9b9;
    border-color: #cfcfcf;
  }
  &.btn--prev {
    margin-left: 0px;
  }
}

.total__summary {
  background: #fafafa;
  padding: 10px 15px;
  max-width: 300px;
  margin: 0 auto 24px;
}
.total__summary__total {
  color: black;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  font-size: 18px;
}
ul.total__summary__list {
  margin: 0px auto;
  display: flex;
  padding: 0px 0px 2px;
  justify-content: center;
  flex-flow: column;

  li {
    padding: 0px 0px;
  }
}
:deep(.multiple__payoptions) {
      max-width: 508px;
    margin: 0px auto 0px;
  .radio__label {
    flex-flow: wrap;
        @media only screen and (max-width: 720px) {
      flex-flow: column;
      padding-bottom: 8px;
      padding-top: 20px;
    }
  }
  .monthly-note {
    width: 100%;
    padding-bottom: 20px;
  }
}

.btn__blue {

  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 24px;
  gap: 4px;
  max-width: 240px;
  background: #1aa8d3;
  border-radius: 6px;
  font-style: normal;
  width: 100%;
background-color: #FFFFFF;
  font-weight: 500;
font-size: 16px;
line-height: 24px;
color: #1aa8d3;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover{
    color: #fdfdfd;
     background: #F87507;
  }
          @media only screen and (max-width: 720px) {
padding: 10px;
font-size: 14px;
line-height: 20px;
          }
}
.btn__white {
border: 1px solid #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 24px;
  gap: 4px;
  max-width: 240px;
  border-radius: 6px;
  font-style: normal;
  width: 100%;
  font-weight: 500;
font-size: 16px;
line-height: 24px;
color: #FFFFFF;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover{
        background: rgba(255, 255, 255, 0.1);
  }
         @media only screen and (max-width: 720px) {
padding: 10px;
font-size: 14px;
line-height: 20px;
          }
}

:deep(.personal__info) {
  background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
  padding: 24px;
  max-width: 790px;
  margin: 0 auto;
   @media only screen and (max-width: 720px) {
      padding: 16px 16px 6px;
   }
      .form-group.form-group--inline{
      margin-bottom: 16px;
    }
}

.donateion__list {
    max-width: 508px;
    margin: auto;
    position: relative;
    width: 100%;
}

.fee-info-container {
    max-width: 508px;
    border-radius: 8px;
    border-width: 1px;
    gap: 12px;
    padding-top: 10px;
    padding-right: 14px;
    padding-bottom: 11px;
    padding-left: 14px;
    border: 1px solid #9ABBFF;
    margin: auto;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
    color: #FFFFFF;
        @media only screen and (max-width: 720px) {
          margin-bottom: 20px;
        }
    :deep(label) {
       padding: 0px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
    color: #FFFFFF;
    flex: 1;
}
:deep(.flex) {
padding-top: 12px;
    display: flex;
}
.amount {
  font-weight: bold;
  display: inline-block;
}
.inline-block {
  display: inline-block;
}
// input[type="checkbox"]#cover:checked {
//   background-color: orange;
//   accent-color: orange; /* For modern browsers */
// }
}
.oudonation hr {
    background: none;
    box-shadow: none;
    height: 0;
    border: none;
    border-bottom: none;
}
h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #ffffff;
    margin-top: 0px;
    margin-bottom: 12px;

}

.donatem__section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;
  align-items: flex-start;
      @media only screen and (max-width: 720px) {
     flex-flow: column;
             justify-content: center;
        align-items: center;
       gap: 0px;
    }
}
.donatem__right {
    max-width: 533px;
    position: relative;
        width: 100%;
}
.donatem__left {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    border-width: 2px;
    padding: 24px;
    max-width: 532px;
    width: 100%;
      @media only screen and (max-width: 720px) {
            padding: 24px 24px 4px 24px;
      }
}

:deep(.dedicate__modals) {
  padding-bottom: 10px;
  max-width: 508px;
    margin: auto;
  label{
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
    color: #FFFFFF;
    line-height: 18px;
    vertical-align: bottom;
  }
      @media only screen and (max-width: 720px) {
        .form-group{
          display: flex;
          align-items: center;
        }

    }
}
input#inHonorOf {
border: 1.5px solid #F7F7F7;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
// content: "✓";

  content: "";
  position: absolute;
  background-color: #FDFDFD;
background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.4446 1.33331L4.33344 7.55554L1.55566 4.72725' stroke='%231aa8d3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 9px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 2px;
    }
}

input#cover{
border: 1.5px solid #F7F7F7;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
  content: "";
  position: absolute;
  background-color: #FDFDFD;
background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.4446 1.33331L4.33344 7.55554L1.55566 4.72725' stroke='%231aa8d3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 9px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 2px;
    }
}

// ::v-deep.honor__row {
//   label{
//       display: none !important;
//   }
    
// }
span.edit-recipient {

display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
gap: 4px;
width: 157px;
height: 36px;
border: 1px solid #FFFFFF;
border-radius: 6px;
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: #FFFFFF;
    text-align: center;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      &:hover{
        background: rgba(255, 255, 255, 0.1);
      }
}

.honor__field{

}
.honor__row.form-group.form-group--inline {
    gap: 16px;
        @media only screen and (max-width: 720px) {
          gap: 12px;
          flex-flow: column;
          display: flex;
          margin-bottom: 16px;
    }
}

input[type="text"],
input[type="email"]
 select{
    padding: 12px;
    // height: 40px;
    // background: rgba(255, 255, 255, 0.1);
    border: 1px solid #595C5F;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #4a4d50;

    &::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
    }
}
/* Placeholder styles for all browser prefixes */
input[type="text"]::placeholder,
input[type="email"]::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]::-webkit-input-placeholder,
input[type="email"]::-webkit-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]::-moz-placeholder,
input[type="email"]::-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]:-ms-input-placeholder,
input[type="email"]:-ms-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]:-moz-placeholder,
input[type="email"]:-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}    

:deep(.personal__info){
input[type="email"],
input[type="text"],
input[type="tel"],
textarea,
 select{
    padding: 12px;
    border: 1px solid #595C5F;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #4a4d50;

option{
  color: black !important;
}    
    &::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
    }
        &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
}
/* Placeholder styles for all browser prefixes */
input[type="text"]::placeholder,
input[type="email"]::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]::-webkit-input-placeholder,
input[type="text"]::-webkit-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]::-moz-placeholder,
input[type="text"]::-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]:-ms-input-placeholder,
input[type="text"]:-ms-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]:-moz-placeholder,
input[type="text"]:-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}    

}

:deep(.personal__title){
    width: 100%
}
// ::v-deep .personal__country{
//     flex: 0 1 48% !important;
//     min-width: 48%;
//     max-width: 48%;
//     margin-left: 16px;
//     padding-right: 0px !important;
// }

.personal__firstrow{
  gap: 16px;
}
.personal__statehide {
    opacity: 0.3 !important;
}
:deep(.personal__phone){
.vue-tel-input {
    // padding: 12px;
    height: 40px;
    background: white;
    // background: rgba(255, 255, 255, 0.1);
    border: 1px solid #595C5F !important;
    border-radius: 0px !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #4a4d50;

    .dropdown {
        background: none;

       .dropdown-arrow {
          color: #4a4d50;
        }
    }

    input[type=tel]{
      border: none;
      background: none;
          &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
    }
              &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
}
    // flex: 0 1 30% !important;
    // min-width: 30%;
    // max-width: 30%;
    // display: flex;
    // padding-right: 0px !important;
    // align-items: center;
    // font-style: normal;
    // font-weight: 400;
    // font-size: 14px;
    // line-height: 20px;
    color: #4a4d50;
}

.directgift__section{

}

.directgift__option{
  
    display: flex;
    margin: 0px auto 12px;
    flex-direction: row;
    align-items: center;
    padding: 0px 16px 0px 0px;
    height: 48px;
    max-width: 395px;
    width: 100%;
    background: #FFFFFF;
    border: 2px solid #EBEBEB;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #080F16;

    input{
      position: absolute;
    opacity: 0;
    display: none;
    cursor: pointer;
        // width: 20px;
        // height: 20px;
        // border: 2px solid #1aa8d3;
    }

    label{
        position: relative;
        padding-left: 40px;
        user-select: none;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #4a4d50;
            width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    }
    input:checked ~ span {
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;
color: #595C5F;
    }

.radiobtn {
    position: absolute;
    left:10px;
    height: 20px;
    width: 20px;
    background-color: #ffffff;
    border: 2px solid #1aa8d3;
    border-radius: 50%;
    &:after{
    top: 3px;
    left: 3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #1aa8d3;
      content: "";
    position: absolute;
    display: none;
    }
} 
input:checked ~ .radiobtn {
    // background-color: #2196F3;
        border: 2px solid #1aa8d3;
    &:after {
    display: block;
  }
}   

}

.designation{
    max-width: 395px;
    margin: 0px auto 16px;
    width: 100%;
    padding-top: 14px;
}

.designation__infotext{
    max-width: 395px;
    margin: auto;
    width: 100%;
    font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
}
.payment__info {
    max-width: 775px;
    margin: auto;
    color: white;
}

.form__subscribe{
    width: 100%;
margin: 0px auto 8px;
max-width: 446px;
display: flex;
align-items: center;
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 18px;
display: flex;
align-items: center;
color: #FFFFFF;
 label{
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
    color: #FFFFFF;
    line-height: 18px;
    flex: 1;
    vertical-align: bottom;
  }

input {
   border: 1.5px solid #F7F7F7;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
  content: "";
  position: absolute;
  background-color: #FDFDFD;
background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.4446 1.33331L4.33344 7.55554L1.55566 4.72725' stroke='%231aa8d3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 9px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 2px;
    }
}
}

  button.ougiving__btn{
       
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 24px;
  gap: 4px;
  max-width: 240px;
  background: #1aa8d3;
  border-radius: 6px;
  font-style: normal;
  width: 100%;
background-color: #FFFFFF;
  font-weight: 500;
font-size: 16px;
line-height: 24px;
color: #1aa8d3;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover{
    color: #fdfdfd;
     background: #F87507;
  }
       @media only screen and (max-width: 720px) {
padding: 10px;
font-size: 14px;
line-height: 20px;
          }
  }

  .btnpayment__text{
      display: flex;
      gap: 4px;
      text-align: center;
      width: 100%;
      text-transform: uppercase;

      flex-direction: row;
      justify-content: center;
      align-items: center;
  }

.personal__firstrow{
  .dform__col{
    padding: 0px !important;
    position: relative;
      min-width: 100%;
      max-width: 100%;
    flex: 0 1 100%;
        @media only screen and (min-width: 720px) {
      min-width: calc((100% - 32px) / 3);
      max-width: calc((100% - 32px) / 3);
    flex: 0 1 calc((100% - 32px) / 3);
        }
  }
}

.dform__rowdouble{
  gap: 16px;
  .dform__col{
    padding: 0px !important;
    position: relative;
      min-width: 100%;
      max-width: 100%;
    flex: 0 1 100%;
            @media only screen and (min-width: 720px) {
      min-width: calc((100% - 16px) / 2);
      max-width: calc((100% - 16px) / 2);
    flex: 0 1 calc((100% - 16px) / 2);
            }
  }
}

:deep(.dform__col){

  .error-label{
    margin-top: 1px;
  }
}

.donation__vector{
  position: absolute;
  bottom: 0;
  right:32px;
  display: none;
      @media only screen and (min-width: 720px) {
       display: flex;
    }
}
.doantion__backlink{
  position: absolute;
  top: 32px;
  left:32px;
  display: flex;
  cursor: pointer;

      @media only screen and (max-width: 720px) {
  top: 13px;
  left:20px;
      }
}

.gift__setup{
  h2{
    margin-bottom: 12px;
  }
}

:deep(.payment__cc){
  max-width: 400px;
  margin: 0px auto;

  .styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
    background: #f87507;
      border: none;
  }
}
.steps-bar__svg{
   @media only screen and (max-width: 720px) {
    display: none;
   }
}

.dedicate__mobile__info{
   @media only screen and (max-width: 720px) {
    display: flex;
    flex-flow: column-reverse;
   }
}

h2.h2__mixed{
  color: white;
    margin-bottom: 20px;
    text-align: center;
        font-weight: 700;
    font-size: 24px;
        line-height: 32px;
   @media only screen and (min-width: 720px) {
        font-size: 40px;
        line-height: 52px;
   }
   span {
    text-transform: capitalize;
    color: #9ABBFF;
  }
}

:deep(.error-label){
    padding-left: 6px;
    font-size: 11px;
    color: red;
    font-weight: 400;
    font-style: normal;
    width: 100%;
    display: block;
    position: absolute;
    &::before {
    content: "*";
    color: red;
    left: 0px;
    position: absolute;
  }
}

:deep(.phonec__consent){
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #FFFFFF;
  label.label__consent{
     font-style: normal;
  font-weight: 400;
      padding-top: 1px;
    font-size: 12px !important;
    line-height: 16px !important;
  color: #FFFFFF; 
  }
  a{

    font-style: normal;
    font-weight: 400;
    font-size: 12px !important;
    line-height: 16px !important;
    color: #9ABBFF;

  }

  input#consent {
border: 1.5px solid #F7F7F7;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
// content: "✓";

  content: "";
  position: absolute;
  background-color: #FDFDFD;
background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.4446 1.33331L4.33344 7.55554L1.55566 4.72725' stroke='%231aa8d3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 9px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 2px;
    }
}
}

.checktext strong {
    padding-bottom: 2px;
    display: block;
}
.checktext p {
    font-size: 15px;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 7px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #133271;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
